import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sa-integration',
  templateUrl: './sa-integration.component.html',
  styleUrls: ['./sa-integration.component.scss']
})
export class SaIntegrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
